import { useLayoutEffect } from 'react'
import store from 'store2'
import { useDispatch, useSelector } from 'react-redux'
import { preselectedCourses } from '../../../pages/searchData'
import { setSearchFilters } from '../../../actions/search-actions'

export default function usePageObserver(activityType) {
  const { searchFilters } = useSelector((state) => state.searchFilters)
  const dispatch = useDispatch()
  useLayoutEffect(() => {
    // eslint-disable-next-line no-undef
    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if(entry.type === 'reload' && activityType === 'courses') {
          store.remove('standardNameIds')
          dispatch(
            setSearchFilters({
              ...searchFilters,
              standard_name_ids: preselectedCourses.reduce((acc, el) => {
                return { ...acc, [el]: true }
              }, {}),
            }),
          )
        }
      })
    })

    observer.observe({ type: 'navigation', buffered: true })
  }, [])
}
